<div class="container pt-100">
    <div class="row">
        <div class="col-md-12 w-100">
            <div role="tabpanel" class="tab-pane fade show">
                <div class="card h-100  my-3 m-0 postjob-table">
                    <div class="card-body">
                        <h5>Post Jobs</h5><hr />
                        <!-- personal detail -->
                        <form [formGroup]="form">
                            <div class="row gutters text-primary">

                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label><b>Hiring Company Name<span style="color:red">*</span></b></label>
                                        <input class="form-control" formControlName="RecruiterName" type="text" placeholder="Recruiter Name">
                                        <small *ngIf="form.controls.RecruiterName.touched && form.controls.RecruiterName.errors?.required" class="p-error">Recruiter Name is required.</small>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label><b>Job Title<span style="color:red">*</span></b></label>
                                        <input class="form-control" formControlName="Jobtitle" type="text" placeholder="Job Title">
                                        <small *ngIf="form.controls.Jobtitle.touched && form.controls.Jobtitle.errors?.required" class="p-error">Job Title is required.</small>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label><b>Required Position<span style="color:red">*</span></b></label>
                                        <input class="form-control" formControlName="RequiredPosition" type="text" placeholder="RequiredPosition" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
                                        <small *ngIf="form.controls.RequiredPosition.touched && form.controls.RequiredPosition.errors?.required" class="p-error">RequiredPosition is required.</small>
                                    </div>
                                </div>

                                <!--<div class="col-lg-12">
                                    <label for="UserName">
                                        Select Skills <span style="color:red">*</span>
                                    </label>
                                    <div style="display: flex; align-items: center;">
                                        <p-multiSelect [options]="Skillslist"
                                                       formControlName="Skills"
                                                       placeholder="Select Skills"
                                                       optionLabel="Skills"
                                                       display="chip"
                                                       [style]="{ width: '100%' }">
                                        </p-multiSelect>
                                        <div class="circle-plus" (click)="open()">
                                            <i class="fa fa-plus"></i>
                                            <span class="tooltip-text">Add skill</span>
                                        </div>
                                    </div>
                                </div>-->

                                <div class="col-lg-12">
                                    <label for="UserName">
                                        Select Skills <span style="color:red">*</span>
                                    </label>
                                    <div style="display: flex; align-items: center;">
                                        <p-multiSelect [options]="Skillslist"
                                                       formControlName="Skills"
                                                       placeholder="Select Skills"
                                                       optionLabel="Skills"
                                                       [style]="{ width: '100%' }">
                                        </p-multiSelect>
                                        <div class="circle-plus" (click)="open()">
                                            <i class="fa fa-plus"></i>
                                            <span class="tooltip-text">Add skill</span>
                                        </div>
                                    </div>

                                    <div class="selected-skills-container mt-2" *ngIf="form.value.Skills && form.value.Skills.length > 0">
                                        <span class="skill-chip" *ngFor="let skill of form.value.Skills">
                                            {{ skill.Skills }}
                                            <i class="fa fa-times-circle remove-skill-icon" (click)="removeSkill(skill)"></i>
                                        </span>
                                    </div>
                                </div>



                                <div class="col-lg-12">
                                    <label for="category">Category Name<span style="color:red">*</span></label>
                                    <div class="add_input uomm">
                                        <p-autoComplete formControlName="CategoryName" [suggestions]="deptList" (completeMethod)="searchCont($event)"
                                                        field="CategoryName" [dropdown]="true" [size]="90"
                                                        placeholder="Select CategoryName" [minLength]="1"
                                                        [style]="{'color': 'black', 'height':'33px'}"
                                                        [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':'rgba(0, 0, 0, 0.24) 0px 3px 8px'}">
                                        </p-autoComplete>
                                    </div>
                                    <small *ngIf="form.controls.CategoryName.touched && form.controls.CategoryName.errors?.required"
                                           class="p-error" style="color:red">CategoryName is required.</small>
                                </div>

                                <div class="col-lg-12">
                                    <label for="category">Salary Range<span style="color:red">*</span></label>
                                    <div class="add_input uomm">
                                        <p-autoComplete formControlName="SalaryRange" [suggestions]="deptList" (completeMethod)="searchCont5($event)"
                                                        field="SalaryRange" [dropdown]="true" [size]="90"
                                                        placeholder="Select SalaryRange" [minLength]="1"
                                                        [style]="{'color': 'black', 'height':'33px'}"
                                                        [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':'rgba(0, 0, 0, 0.24) 0px 3px 8px'}">
                                        </p-autoComplete>
                                    </div>
                                    <small *ngIf="form.controls.SalaryRange.touched && form.controls.SalaryRange.errors?.required"
                                           class="p-error" style="color:red">SalaryRange is required.</small>
                                </div>
                                <div class="col-lg-12">
                                    <label for="category">Type Of Job<span style="color:red">*</span></label>
                                    <div class="add_input uomm">
                                        <p-autoComplete formControlName="TypeName" [suggestions]="deptList" (completeMethod)="searchCont2($event)"
                                                        field="TypeName" [dropdown]="true" [size]="90"
                                                        placeholder="Select TypeName" [minLength]="1"
                                                        [style]="{'color': 'black', 'height':'33px'}"
                                                        [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':'rgba(0, 0, 0, 0.24) 0px 3px 8px'}">
                                        </p-autoComplete>
                                    </div>
                                    <small *ngIf="form.controls.TypeName.touched && form.controls.TypeName.errors?.required"
                                           class="p-error" style="color:red">TypeName is required.</small>
                                </div>
                                <div class="col-lg-12">
                                    <label for="category">Languages<span style="color:red">*</span></label>
                                    <div class="add_input uomm">
                                        <p-autoComplete formControlName="Languages" [suggestions]="deptList" (completeMethod)="searchCont3($event)"
                                                        field="Languages" [dropdown]="true" [size]="90"
                                                        placeholder="Select Languages" [minLength]="1"
                                                        [style]="{'color': 'black', 'height':'33px'}"
                                                        [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':'rgba(0, 0, 0, 0.24) 0px 3px 8px'}">
                                        </p-autoComplete>
                                    </div>
                                    <small *ngIf="form.controls.Languages.touched && form.controls.Languages.errors?.required"
                                           class="p-error" style="color:red">Languages is required.</small>
                                </div>

                                <div class="col-lg-12">
                                    <label for="category">Experience<span style="color:red">*</span></label>
                                    <div class="add_input uomm">
                                        <p-autoComplete formControlName="Experience" [suggestions]="deptList" (completeMethod)="searchCont6($event)"
                                                        field="Experience" [dropdown]="true" [size]="90"
                                                        placeholder="Select Experience" [minLength]="1"
                                                        [style]="{'color': 'black', 'height':'33px'}"
                                                        [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':'rgba(0, 0, 0, 0.24) 0px 3px 8px'}">
                                        </p-autoComplete>
                                    </div>
                                    <small *ngIf="form.controls.Experience.touched && form.controls.Experience.errors?.required"
                                           class="p-error" style="color:red">Experience is required.</small>
                                </div>

                                <div class="col-lg-12">
                                    <label for="category">City Name<span style="color:red">*</span></label>
                                    <div class="add_input uomm">
                                        <p-autoComplete formControlName="CityName" [suggestions]="deptList" (completeMethod)="searchCont1($event)"
                                                        field="CityName" [dropdown]="true" [size]="90"
                                                        placeholder="Select CityName" [minLength]="1"
                                                        [style]="{'color': 'black', 'height':'33px'}"
                                                        [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':'rgba(0, 0, 0, 0.24) 0px 3px 8px'}">
                                        </p-autoComplete>
                                    </div>
                                    <small *ngIf="form.controls.CityName.touched && form.controls.CityName.errors?.required"
                                           class="p-error" style="color:red">CityName is required.</small>
                                </div>

                                <div class="col-lg-12">
                                    <label for="category">Qualification Name<span style="color:red">*</span></label>
                                    <div class="add_input uomm">
                                        <p-autoComplete formControlName="Qualification" [suggestions]="deptList" (completeMethod)="searchCont7($event)"
                                                        field="Qualification" [dropdown]="true" [size]="90"
                                                        placeholder="Select Qualification" [minLength]="1"
                                                        [style]="{'color': 'black', 'height':'33px'}"
                                                        [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':'rgba(0, 0, 0, 0.24) 0px 3px 8px'}">
                                        </p-autoComplete>
                                    </div>
                                    <small *ngIf="form.controls.Qualification.touched && form.controls.Qualification.errors?.required"
                                           class="p-error" style="color:red">Qualification is required.</small>
                                </div>

                                <div class=" col-12 mt-3 text-primary">
                                    <label for="eMail">Job Description<span style="color:red">*</span></label>
                                    <div class="form-group col-md-12 mt-2">
                                        <textarea id="comment" name="comment" formControlName="JobDescription" cols="40" rows="5" class="form-control"></textarea>
                                        <small *ngIf="form.controls.JobDescription.touched && form.controls.JobDescription.errors?.required"
                                               class="p-error" style="color:red">JobDescription is required.</small>
                                    </div>
                                </div>

                                <div class="row gutters mt-4">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <!--<span class="status-text border border-danger-subtle p-2">Status: Paid</span>-->
                                            <button type="button" id="submit" name="submit" [disabled]="form.invalid" (click)="onSubmit(form.value)" class="btn btn-danger upload">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>


                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal" id="myModal2" style="margin-top:9rem;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header state modal-primary d-flex justify-content-between align-items-center">
                <h4 style="text-align:left;" class="modal-title" id="modal-primary-label">Add skills</h4>
                <button type="button" class="close closendsubmit" data-dismiss="modal" aria-label="Close" (click)="Close()">
                    <span aria-hidden="true">X</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label>Skills<span style="color:red">*</span></label>
                    <input [(ngModel)]="Rskills" class="form-control Caps" placeholder="Enter skills" type="text" style="width:450px">
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="closendsubmit  submit" (click)="addSkill(Rskills)">Submit</button>
            </div>
        </div>
    </div>
</div>
